// extracted by mini-css-extract-plugin
module.exports = {"wrap":"mention_wrap__sjS56","loading":"mention_loading__zlS6U"};